import { faGripVertical } from '@fortawesome/pro-regular-svg-icons';
import { FC } from 'react';
import { Box } from 'src/components/Box';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import { Tooltip } from 'src/components/Tooltip';

import { automationDragHighlightBg, disabledAutomationColors } from './automationDragStyles';

interface AutomationDragHandleProps {
  active?: boolean;
  disabled?: boolean;
  disabledTooltip?: string;
  label: string;
  /** Muted handle for disabled automations and drop placeholders. */
  muted?: boolean;
  /** Muted handle for the stationary drop placeholder (not the drag overlay). */
  placeholder?: boolean;
}

export const AutomationDragHandle: FC<AutomationDragHandleProps> = ({
  active = false,
  disabled = false,
  disabledTooltip,
  label,
  muted = false,
  placeholder = false,
}) => {
  const handle = (
    <IconButton
      aria-label={label}
      disabled={disabled}
      size="small"
      sx={[
        {
          color: active ? 'primary.dark' : 'text.secondary',
          cursor: disabled ? 'not-allowed' : 'grab',
          flexShrink: 0,
        },
        placeholder || muted
          ? {
              bgcolor: 'transparent',
              color: placeholder ? 'text.disabled' : disabledAutomationColors.dragHandle,
            }
          : active
            ? (theme) => ({
                ...automationDragHighlightBg(theme),
                ...theme.applyStyles('dark', {
                  color: 'primary.11',
                }),
              })
            : { bgcolor: 'transparent' },
      ]}
    >
      <Icon icon={faGripVertical} size="xsmall" />
    </IconButton>
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip title={disabledTooltip}>
        <Box component="span" display="inline-flex">
          {handle}
        </Box>
      </Tooltip>
    );
  }

  return handle;
};
